import { c as _c } from "react/compiler-runtime";
import { IconCamera } from "@tabler/icons-react";
import { ExportButton } from "@/components/domain/export-button";
import { ScreenshotPopover } from "@/components/domain/screenshot-popover";
import { ToolsDropdown } from "@/components/domain/tools-dropdown";
import { TrackDomainButton } from "@/components/domain/track-domain-button";
import { Favicon } from "@/components/icons/favicon";
import { Spinner } from "@domainstack/ui/spinner";
import { cn } from "@domainstack/ui/utils";
interface DomainReportHeaderProps {
  domain: string;
  domainId?: string;
  /** Whether the domain is confirmed registered. If false, render loading states. */
  isRegistered?: boolean;
}

/**
 * Header section for domain report showing domain name with favicon,
 * external link, export button, and tools dropdown.
 */
export function DomainReportHeader(t0) {
  const $ = _c(20);
  let className;
  let domain;
  let domainId;
  let isRegistered;
  let props;
  if ($[0] !== t0) {
    ({
      domain,
      domainId,
      isRegistered,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = domain;
    $[3] = domainId;
    $[4] = isRegistered;
    $[5] = props;
  } else {
    className = $[1];
    domain = $[2];
    domainId = $[3];
    isRegistered = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("flex min-w-0 items-center justify-between gap-4", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== domain || $[9] !== domainId || $[10] !== isRegistered) {
    t2 = isRegistered ? <ScreenshotPopover domain={domain} domainId={domainId} align="start" side="bottom" sideOffset={8}><a href={`https://${domain}`} target="_blank" rel="noopener" className="flex min-w-0 items-center gap-2"><Favicon domain={domain} className="size-5 shrink-0" /><h2 className="truncate text-xl font-semibold tracking-tight" title={domain}>{domain}</h2><IconCamera className="mr-3 ml-0.5 size-3.5 shrink-0 text-foreground/65" aria-hidden={true} /></a></ScreenshotPopover> : <span className="flex min-w-0 cursor-default items-center gap-2"><Favicon domain={domain} className="size-5 shrink-0" /><h2 className="truncate text-xl font-semibold tracking-tight" title={domain}>{domain}</h2><Spinner className="ml-0.5 size-3.5 shrink-0 text-foreground/65" aria-hidden="true" /></span>;
    $[8] = domain;
    $[9] = domainId;
    $[10] = isRegistered;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== domain || $[13] !== isRegistered) {
    t3 = <div className="flex shrink-0 items-center gap-2"><TrackDomainButton domain={domain} enabled={isRegistered} /><ExportButton domain={domain} enabled={isRegistered} /><ToolsDropdown domain={domain} enabled={isRegistered} /></div>;
    $[12] = domain;
    $[13] = isRegistered;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== props || $[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
    t4 = <div className={t1} {...props}>{t2}{t3}</div>;
    $[15] = props;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}